export const LANGUAGE_STORAGE_KEY = 'xr_ui_language';

export const LANGUAGE_OPTIONS = [
  { value: 'zh-CN', label: '简体中文' },
  { value: 'en-US', label: 'English' }
];

export const REGISTER_LANGUAGE_OPTIONS = [
  ...LANGUAGE_OPTIONS,
  { value: 'ru-RU', label: 'Русский' },
  { value: 'vi-VN', label: 'Tiếng Việt' },
  { value: 'ar-SA', label: 'العربية' }
];

export function normalizeUiLanguage(value) {
  const normalized = String(value || '').trim().toLowerCase().replace('_', '-');
  if (['1', '2', '4', 'zh', 'zh-cn', 'zh-tw', 'zh-hk', 'zh-hans', 'zh-hant'].includes(normalized)) {
    return 'zh-CN';
  }
  if (normalized === '13' || normalized === 'ru' || normalized.startsWith('ru-')) {
    return 'ru-RU';
  }
  if (normalized === '16' || normalized === 'vi' || normalized === 'vn' || normalized.startsWith('vi-') || normalized.startsWith('vn-')) {
    return 'vi-VN';
  }
  if (normalized === '7' || normalized === 'ar' || normalized.startsWith('ar-')) {
    return 'ar-SA';
  }
  return 'en-US';
}

export function getInitialUiLanguage() {
  if (typeof window === 'undefined') {
    return 'zh-CN';
  }

  const params = new URLSearchParams(window.location.search);
  const queryLanguage = params.get('language') || params.get('lang');
  if (queryLanguage) {
    return normalizeUiLanguage(queryLanguage);
  }

  try {
    const storedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (storedLanguage) {
      return normalizeUiLanguage(storedLanguage);
    }
  } catch (error) {
    // Ignore storage restrictions inside embedded browsers.
  }

  return normalizeUiLanguage(window.navigator?.language || 'zh-CN');
}

export function getGameLanguageId(language) {
  return {
    'zh-CN': 1,
    'en-US': 3,
    'ar-SA': 7,
    'ru-RU': 13,
    'vi-VN': 16
  }[normalizeUiLanguage(language)] || 3;
}

export function isEnglish(language) {
  return normalizeUiLanguage(language) === 'en-US';
}
